import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { Loader2Icon } from 'lucide-react'
import { Button } from 'ui/button'
import { toast } from 'ui/sonner'

import { LinkButton } from '~/components/link-button'

export const ChangePaymentMethodForm = () => {
  const stripe = useStripe()
  const elements = useElements()
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!stripe || !elements) return

    setIsLoading(true)
    try {
      const elementsSubmitResult = await elements.submit()
      if (elementsSubmitResult.error) {
        console.error({ message: 'Error changing payment method', error: elementsSubmitResult.error })
        toast.error(t('Something went wrong'))

        return setIsLoading(false)
      }

      const result = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/settings/subscription/change-payment-method-success`,
        },
      })
      if (result.error) {
        console.error({ message: 'Error changing payment method', error: result.error })
        toast.error(t('Something went wrong'))

        return setIsLoading(false)
      }
    } catch (error) {
      console.error({ message: 'Error changing payment method', error })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form className="w-[90vw] max-w-2xl" onSubmit={onSubmit}>
      <div className="rounded-md border border-border bg-card p-3 shadow-lg">
        <PaymentElement options={{}} />
      </div>
      <div className="mt-4 flex justify-end gap-4">
        <LinkButton to="/settings/subscription/usage" variant="outline">
          {t('Cancel')}
        </LinkButton>
        <Button disabled={isLoading} type="submit">
          {t('Submit')}
          {isLoading && <Loader2Icon className="ml-2 size-4 animate-spin" />}
        </Button>
      </div>
    </form>
  )
}
